import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { fmtTL, fmtDate } from "@/lib/format";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { toast } from "sonner";
import { Plus, Trash2 } from "lucide-react";

export default function Suppliers() {
  const { isAdmin } = useAuth();
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name: "", contact: "", phone: "", email: "", address: "", tax_no: "", note: "" });
  const load = async () => setItems((await api.get("/suppliers")).data);
  useEffect(() => { load(); }, []);
  const submit = async (e) => {
    e.preventDefault();
    if (!form.name) return toast.error("Ad gerekli");
    await api.post("/suppliers", form); toast.success("Eklendi"); setOpen(false); load();
    setForm({ name: "", contact: "", phone: "", email: "", address: "", tax_no: "", note: "" });
  };
  const del = async (id) => { if (!window.confirm("Silinsin mi?")) return; await api.delete(`/suppliers/${id}`); load(); };

  return (
    <div className="space-y-6" data-testid="suppliers-page">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-extrabold tracking-tight">Tedarikçiler</h1>
          <p className="text-sm text-muted-foreground">{items.length} tedarikçi</p>
        </div>
        <Dialog open={open} onOpenChange={setOpen}>
          <DialogTrigger asChild><Button><Plus size={16} className="mr-1" /> Yeni Tedarikçi</Button></DialogTrigger>
          <DialogContent className="bg-popover">
            <DialogHeader><DialogTitle>Yeni Tedarikçi</DialogTitle></DialogHeader>
            <form onSubmit={submit} className="space-y-3">
              <div><Label>Firma Adı *</Label><Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} /></div>
              <div className="grid grid-cols-2 gap-3">
                <div><Label>Yetkili</Label><Input value={form.contact} onChange={(e) => setForm({ ...form, contact: e.target.value })} /></div>
                <div><Label>Telefon</Label><Input value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} /></div>
              </div>
              <Button type="submit" className="w-full">Kaydet</Button>
            </form>
          </DialogContent>
        </Dialog>
      </div>
      <Card className="p-0">
        <Table>
          <TableHeader><TableRow><TableHead>Firma</TableHead><TableHead>Yetkili</TableHead><TableHead>Telefon</TableHead><TableHead></TableHead></TableRow></TableHeader>
          <TableBody>
            {items.map((s) => (
              <TableRow key={s.id}>
                <TableCell className="font-semibold">{s.name}</TableCell>
                <TableCell>{s.contact}</TableCell>
                <TableCell>{s.phone}</TableCell>
                <TableCell>{isAdmin && <Button variant="ghost" size="icon" onClick={() => del(s.id)} data-testid={`supplier-delete-${s.id}`}><Trash2 size={14} /></Button>}</TableCell>
              </TableRow>
            ))}
            {items.length === 0 && <TableRow><TableCell colSpan={4} className="text-center py-8 text-muted-foreground">Henüz tedarikçi yok</TableCell></TableRow>}
          </TableBody>
        </Table>
      </Card>
    </div>
  );
}
